import { render, staticRenderFns } from "./SummaryBooking.vue?vue&type=template&id=3126ceb2"
import script from "./SummaryBooking.vue?vue&type=script&lang=js"
export * from "./SummaryBooking.vue?vue&type=script&lang=js"
import style0 from "./SummaryBooking.vue?vue&type=style&index=0&id=3126ceb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports